import { render, staticRenderFns } from "./OfferContracts.vue?vue&type=template&id=180b91ac&"
import script from "./OfferContracts.vue?vue&type=script&lang=ts&"
export * from "./OfferContracts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports